<template>
  <div class="footer">
    <div style="width: 100%;padding: 30px 30px 10px 30px;box-sizing: border-box;display: flex;align-items: center">
      <el-image :src="logoB" style="width: 100px"></el-image>
    </div>
    <div
        style="width: 100%;padding: 50px 10px 10px 10px;box-sizing: border-box;display: flex;justify-content:space-around;">
      <div :style="index != 0?'margin-left: 20px':'display: none'" v-for="(item,index) in  store.state.navigationBar">
        <div @click="store.commit('gotoUrl',{url:item.url,bar:item.title,barTitleUrl:item.url})"
             v-if="item.bar != null" class="footerT">{{ item.title }}
        </div>
        <div @click="store.commit('gotoUrl',{url:bar.url,bar:bar.name,barTitleUrl:item.url})" v-for="bar in item.bar"
             class="footerZi">
          {{ bar.footer != null ? bar.footer : bar.name }}
        </div>
      </div>
    </div>
    <el-divider/>
    <div style="padding: 0px 15px 15px;box-sizing: border-box;color: #989898;width: 100%;opacity: 0.5">
      Copyright ©2024 Shenzhen Irplus Technology Co.,LTD. All rights Reserved. 铱加科技 版权所有
      <span style="cursor: pointer" @click="beian">粤ICP备2024261021号</span>
      <div style="display: flex;align-items: center">
        <el-image style="margin-right: 5px;width: 15px;height: 15px" :src="gong"></el-image>
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44030002003953" rel="noreferrer" style="color: #939496" target="_blank">粤公网安备44030002003953</a>
      </div>
    </div>
  </div>
</template>
<script setup>
import {inject, onMounted, defineEmits, defineProps, ref, reactive, getCurrentInstance} from 'vue';
import {useRouter} from "vue-router";
import logoB from '@/assets/logo/logo白.png'
import weixin from '@/assets/logo/微信.png'
import weibo from '@/assets/logo/微博.png'
import eweima from '@/assets/logo/二维码.png'
import store from "@/store";

const router = useRouter();

const beian = () => {
  window.open('https://beian.miit.gov.cn')
}

onMounted(() => {
})
</script>

<style scoped lang="less">
.footer {
  background-color: #1a4558;
  color: white;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  box-sizing: border-box;
}

.footerT {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 10px;
  cursor: pointer
}

.footerZi {
  color: #989898;
  margin-bottom: 10px;
  cursor: pointer;
}

.footerZi:hover {
  color: white;
}
</style>
